<template>
    <div class="container dropdown-content text-left py-5">
        <div>
            <div class="v1" v-if="!categoryIsEmpty && categories.length">
                <div class="row" v-if="categories[0] && categories[0].Children">
                    <div class="col-3">
                        <ul v-for="category in categories[0].Children.slice(0,2)" class="mb-5">
                            <li>
                                <a :href="categoriesUrl + '/' + category.Slug">
                                    <span class="value">{{ category.Title }}</span>
                                </a>
                            </li>

                            <div v-if="category.HasChildren === true">
                                <li v-for="childCategory in category.Children.slice(0,4)" class="submenu-categories">
                                    <a :href="categoriesUrl + '/' + childCategory.Slug">
                                        <span class="value">{{ childCategory.Title }}</span>

                                    </a>
                                </li>

                                <li class="submenu-categories">
                                    <a :href="categoriesUrl + '/' + category.Slug">
                                        <span class="value blue-text"><i class="fa fa-chevron-right micro-text"></i> Bekijk alles</span>
                                    </a>
                                </li>
                            </div>

                        </ul>
                    </div>
                    <div class="col-3">
                        <ul v-for="category in categories[0].Children.slice(2,4)" class="mb-5">
                            <li>
                                <a :href="categoriesUrl + '/' + category.Slug">
                                    <span class="value">{{ category.Title }}</span>
                                </a>
                            </li>

                            <div v-if="category.HasChildren === true">
                                <li v-for="childCategory in category.Children.slice(0,4)" class="submenu-categories">
                                    <a :href="categoriesUrl + '/' + childCategory.Slug">
                                        <span class="value">{{ childCategory.Title }}</span>

                                    </a>
                                </li>

                                <li class="submenu-categories">
                                    <a :href="categoriesUrl + '/' + category.Slug">
                                        <span class="value blue-text"><i class="fa fa-chevron-right micro-text"></i> Bekijk alles</span>
                                    </a>
                                </li>
                            </div>
                        </ul>
                    </div>
                    <div class="col-3">
                        <ul v-for="category in categories[0].Children.slice(4,12)">
                            <li class="mb-4">
                                <a :href="categoriesUrl + '/' + category.Slug">
                                    <span class="value">{{ category.Title }}</span>
                                </a>
                            </li>
                        </ul>
                        <ul v-for="category in categories[0].Children.slice(0,1)">
                            <li>
                                <a :href="categoriesUrl + '/' + categories[0].Slug ">
                                    <i class="fa fa-chevron-right tiny-text"></i> <span class="value">Alle categorieën</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <a :href="ImageUrl" class="p-0" :id="clickId">
                            <img height="500" width="500" class="img-responsive m-auto" :src="imageSrc" style="max-height: 250px;" />
                        </a>
                    </div>
                </div>


            </div>



            <div class="v2" v-if="categoryIsEmpty">

                <div class="row" v-if="categories[0] && categories[0].Children">
                    <div class="col-3">
                        <ul v-for="category in categories[0].Children.slice(0, (Math.round((categories[0].Children.length + 1) / 3)))">
                            <li class="mb-4">
                                <a :href="categoriesUrl + '/' + category.Slug">
                                    <span class="value">{{ category.FrontendTitle }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <ul v-for="category in categories[0].Children.slice((Math.round((categories[0].Children.length + 1) / 3)), (Math.round((categories[0].Children.length + 1) / 3) * 2))">
                            <li class="mb-4">
                                <a :href="categoriesUrl + '/' + category.Slug">
                                    <span class="value">{{ category.FrontendTitle }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <ul v-for="category in categories[0].Children.slice((Math.round((categories[0].Children.length + 1) / 3) * 2))">
                            <li class="mb-4">
                                <a :href="categoriesUrl + '/' + category.Slug">
                                    <span class="value">{{ category.FrontendTitle }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-3">
                        <a :href="ImageUrl" class="p-0" :id="clickId">
                            <img height="500" width="500" class="img-responsive m-auto" :src="imageSrc" style="max-height: 250px;" />
                        </a>
                    </div>
                </div>

            </div>
            <div v-if="!categories.length">
                <div class="col loader p-5">
                    <div class="logo"></div>
                    <div class="sk-spinner sk-spinner-three-bounce">
                        <div class="loadball sk-bounce1"></div>
                        <div class="loadball sk-bounce2"></div>
                        <div class="loadball sk-bounce3"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: [
            'categoryId',
            'categoriesUrl',
            'imageSrc',
            'ImageUrl',
            'clickId'
        ],

        watch: {
            'categoryId': function(categoryId) {

                if (categoryId) {
                    this.getCategories(categoryId);
                }
            }
        },

        data() {
            return {
                categories: [],
                categoryIsEmpty: false,
                loading: true
            }
        },

        mounted() {
            $('#submenu-category-'+this.categoryId).on('mouseenter', this.getCategories);
        },

        methods: {
            getCategories: function() {

                if(!this.loading){
                    return false;
                }
                axios.get('/api/categories/' + this.categoryId + '/tree')
                    .then(response => {
                        if (!'data' in response) {
                            return null;
                        }

                        let result = response['data'];

                        if (!'Categories' in result) {
                            return null;
                        }

                        this.categories = result['Categories'];

                        this.isEmptySubCategory();
                    }).finally(
                    this.loading = false
                );
            },
            isEmptySubCategory: function() {

                let emptyCategoryCounter = 0;

                for (let i = 1; i <= 6; i++) {
                    if (true == this.categories[0].Children[i].HasChildren) {
                    } else {
                        emptyCategoryCounter++;
                    }
                }

                this.categoryIsEmpty = false;
                if (emptyCategoryCounter >= 4) {
                    this.categoryIsEmpty = true;
                }
            }
        }
    }
</script>
